// extracted by mini-css-extract-plugin
export default {"mainDiv":"InstagramPopup_mainDiv__eyhRg","container":"InstagramPopup_container__h+Y+g","button":"InstagramPopup_button__Bcuik"};